export default {
  LOCAL: "local",
  PROD: "production",
  STAGE: "stage",
};
